
import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import ProductionPlanning from './ProductionPlanning';
import Performance from './Performance';
import NcQuality from './NcQuality';
import Planshift from './Planshift/PlanShift';
import ProductionActivity from './dailyactivity/ProductionDailyActivity';
import { TrendingUp } from 'react-feather';
import { TrendingDown } from 'lucide-react';
import { BsCheckCircleFill } from 'react-icons/bs';
import ResourceManagement from './ResourceManagement';
import MonthlyProductionSummaryModal from './MonthlyProductionSummaryModal'
import GenerateReport from '../modal/GenerateReport';
import SupervisorDashboard from '../SupervisorDashboard/SupervisorDashboard';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
const Management = () => {
    const [monthlyProduction, setMonthlyProduction] = useState(false)
    const [generateReport, setGenerateReport] = useState(false)
    const [activeTab, setActiveTab] = useState('Production Planning');
    const [metrics, setMetrics] = useState([]);
    const [managerDashboard, setManagerDashboard] = useState([])

    const fetchmanagerDashboard = async () => {
        const token = getAuthToken();
        if (!token) return;

        try {
            const response = await axios.get(`${config.API}/manager/dashboard`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const result = response?.data;
            if (result?.success) {
                setManagerDashboard(result)
            } else {
                console.warn("API call failed:", result?.message || "Something went wrong");
            }
        } catch (err) {
            console.error("Error fetching fetchmanagerDashboard:", err.message);
        }
    };
    useEffect(() => {
        fetchmanagerDashboard()
    }, [])
    const renderContent = () => {
        switch (activeTab) {
            case 'Production Planning':
                return <ProductionPlanning />;
            case 'Performance':
                return <Performance />;
            case 'NC & Quality':
                return <NcQuality />;
            case 'Resource Management':
                return <ResourceManagement />;
            case 'Plan Shift':
                return <Planshift />
            case 'Production Activity':
                return <ProductionActivity />
            case 'Supervisor Dashboard':
                return <SupervisorDashboard />
            default:
                return <ProductionPlanning />;
        }
    };
    const production = Number(managerDashboard?.production) || 0;
    const target = Number(managerDashboard?.target) || 0;
    const monthlyProductions = target > 0 ? ((production / target) * 100).toFixed(2) : 0;
    useEffect(() => {
        if (managerDashboard) {
            setMetrics([
                {
                    title: "Monthly Production",
                    value: `${Number(monthlyProductions).toFixed(2)}%`,
                    subtitle: 'Monthly Production Target',
                    icon: (
                        <div
                            style={{
                                backgroundColor: "#e0ebff",
                                borderRadius: "50%",
                                padding: "10px",
                                width: "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <TrendingUp color="#1D4ED8" size={18} />
                        </div>
                    ),
                },
                {
                    title: "Machine Utilization",
                    value: `${(Number(managerDashboard?.machineUti) || 0).toFixed(2)}%`,
                    subtitle: "from last month",
                    icon: (
                        <div style={{
                            backgroundColor: '#b0f0d8ff',
                            borderRadius: '50%',
                            padding: '10px',
                            width: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <TrendingUp color="#0c7549ff" size={18} />
                        </div>
                    ),
                },
                {
                    title: "Quality Metrics",
                    value: `${(Number(managerDashboard?.quality) || 0).toFixed(2)}%`,
                    subtitle: "First Pass Yield",
                    icon: (
                        <div style={{
                            backgroundColor: '#fff4c2',
                            borderRadius: '50%',
                            padding: '10px',
                            width: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <TrendingDown color="#8B2500" size={18} />
                        </div>
                    ),
                },
                {
                    title: "Material Efficiency",
                    value: Number(managerDashboard?.resourceefficiency || 0).toFixed(2),
                    subtitle: "Resource Management",
                    icon: (
                        <div
                            style={{
                                backgroundColor: "#e0ebff",
                                borderRadius: "50%",
                                padding: "10px",
                                width: "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <BsCheckCircleFill color="#1D4ED8" size={18} />
                        </div>
                    ),
                },
            ]);
        }
    }, [managerDashboard]);
    return (
        <div className="container-fluid p-4" style={{ background: "#EEF2F8" }}>
            <div className="row font_family">
                <div className="col-lg-1" />
                <div className="col-lg-10">
                    <div className="row">
                        <div className="row align-items-center mb-4">
                            <div className="col-12 col-md-6">
                                <strong className='fs-4'>Production Manager Dashboard</strong>
                            </div>
                            <div className="col-12 col-md-6 text-md-end mt-3 mt-md-0">
                                <div className=' d-inline-block px-2 py-1 rounded'>
                                    <button className='btn btn-dark' onClick={() => setGenerateReport(true)} >Generate Report</button>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4 ms-1">
                            {metrics.map((metric, idx) => (
                                <div className="col-12 col-sm-6 col-md-3 mb-3" key={idx} style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        if (metric.title === "Monthly Production") {
                                            setMonthlyProduction(true);
                                        }
                                    }}
                                >
                                    <Card border={metric.color} className='w-100 h-100'>
                                        <Card.Body>
                                            <Card.Title>{metric.title}</Card.Title>
                                            <h4 className="fw-bold d-flex justify-content-between align-items-center">
                                                {metric.value}
                                                <span>{metric.icon}</span>
                                            </h4>
                                            <small>{metric.subtitle}</small>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ))}
                        </div>
                        <div
                            className="d-flex flex-nowrap gap-2 rounded-3 p-2 mt-2 mb-3 shadow-sm"
                            style={{ background: "#e0e9fb" }}
                        >
                            {[
                                "Production Planning",
                                "Performance",
                                "NC & Quality",
                                "Resource Management",
                                "Plan Shift",
                                "Production Activity",
                                "Supervisor Dashboard"
                            ].map((tab) => (
                                <button
                                    key={tab}
                                    type="button"
                                    onClick={() => setActiveTab(tab)}
                                    className={`btn flex-fill rounded-3 fw-semibold ${activeTab === tab
                                        ? "btn-primary shadow-sm"
                                        : "btn-light text-secondary"
                                        }`}
                                    style={{
                                        minHeight: "44px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        border:
                                            activeTab === tab
                                                ? "none"
                                                : "1px solid #d8e0ef",
                                    }}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="mt-2">
                            {renderContent()}
                        </div>

                    </div>
                </div>
                <div className="col-lg-1" />
            </div>
            {/* MonthlyProductionBoardModal */}
            <MonthlyProductionSummaryModal
                show={monthlyProduction}
                handleClose={() => setMonthlyProduction(false)}
            />
            {/* GenerateReport */}
            <GenerateReport
                show={generateReport}
                handleClose={() => setGenerateReport(false)}
            />
        </div>
    );
};



function TabItem({ label, icon, active, onClick }) {
    return (
        <div
            className={`flex-fill text-center py-2 rounded d-flex align-items-center justify-content-center gap-2 ${active ? 'bg-light text-dark fw-bold' : ''
                }`}
            style={{ cursor: 'pointer' }}
            onClick={onClick}
        >
            {icon}
            <span>{label}</span>
        </div>
    );
}

export default Management;